module.exports = __webpack_public_path__ + "img/22.ed6b9d69.png";